import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonApiService } from '../../../common-api.service';
import { SpeakerService } from '../../../speaker.service';
import { SnackbarService } from '../../../snackbar.service';
import {
  MonthOption,
  buildMonthOptions,
  findMonthByMonthYear,
  findMonthOption,
} from '../../../util/month-options.util';

@Component({
  selector: 'app-doctor-business-summary',
  templateUrl: './doctor-business-summary.component.html',
  styleUrls: ['./doctor-business-summary.component.css']
})
export class DoctorBusinessSummaryComponent implements OnInit, OnDestroy {
  public reportData: any[] = [];

  public monthOptions: MonthOption[] = [];
  public selectedMonthValue: string;

  // Display config consumed by app-report-list-container
  displayColumns = [
    'doctor_name',
    'business_amount',
    'completed_cases',
  ];
  displayHeaders = [
    'Doctor Name',
    'Business Amount',
    'Cases Completed',
  ];

  constructor(
    public speaker: SpeakerService,
    private api: CommonApiService,
    private snackbar: SnackbarService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.speaker.listData = [];
    this.monthOptions = buildMonthOptions();

    // Default to current month, or month/year passed via query params (e.g. from dashboard "View More")
    const qp = this.route.snapshot.queryParamMap;
    const qMonth = Number(qp.get('month'));
    const qYear = Number(qp.get('year'));
    const found = qMonth && qYear ? findMonthByMonthYear(this.monthOptions, qMonth, qYear) : undefined;
    this.selectedMonthValue = (found || this.monthOptions[0]).value;

    this.generateReport();
  }

  ngOnDestroy(): void {
    this.speaker.exportBackend = null;
  }

  get selectedMonthLabel(): string {
    return findMonthOption(this.monthOptions, this.selectedMonthValue)?.label || '';
  }

  generateReport(): void {
    const selected = findMonthOption(this.monthOptions, this.selectedMonthValue);
    if (!selected) {
      return;
    }

    const payload = {
      month: selected.month,
      year: selected.year,
    };

    this.speaker.listData = [];
    this.speaker.isLoading = true;
    this.api.callRoute('doctor', '/business_summary', payload).subscribe({
      next: (res: any[]) => {
        this.speaker.isLoading = false;
        this.reportData = (res || []).map(r => ({
          ...r,
          business_amount: Number(r.business_amount || 0).toFixed(2),
        }));
        this.speaker.listData = this.reportData;
        this.speaker.model = 'doctor';
        this.speaker.displayColumns = this.displayColumns;
        this.speaker.displayHeaders = this.displayHeaders;
        this.speaker.exportBackend = {
          model: 'doctor',
          route: '/business_summary/export',
          payload: { month: selected.month, year: selected.year },
          filename: `${this.selectedMonthLabel}.xlsx`,
        };

        if (this.reportData.length === 0) {
          this.snackbar.info('No records found for the selected month');
        }
      },
      error: () => {
        this.speaker.isLoading = false;
        this.snackbar.error('Failed to load report');
      }
    });
  }
}
